import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';
export class contactParamConfigModel {
  constructor(private moduleParamConfigGlob: ModuleParamGlobConfigService) {}

  paramData = {
    firstName: {
      label: this.moduleParamConfigGlob.getLabel('Contact', 'first_name', 'First Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('Contact', 'first_name'),
      isRequired: this.moduleParamConfigGlob.isRequired('Contact', 'first_name'),
    },
    lastName: {
      label: this.moduleParamConfigGlob.getLabel('Contact', 'last_name', 'Last Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('Contact', 'last_name'),
      isRequired: this.moduleParamConfigGlob.isRequired('Contact', 'last_name'),
    },
    phoneNo: {
      label: this.moduleParamConfigGlob.getLabel('Contact', 'phone', 'Phone'),
      isVisible: this.moduleParamConfigGlob.isVisible('Contact', 'phone'),
      isRequired: this.moduleParamConfigGlob.isRequired('Contact', 'phone'),
    },
    email: {
      label: this.moduleParamConfigGlob.getLabel('Contact', 'email', 'Email'),
      isVisible: this.moduleParamConfigGlob.isVisible('Contact', 'email'),
      isRequired: this.moduleParamConfigGlob.isRequired('Contact', 'email'),
    },
  };
}
